var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"title space-between vertical-center"},[(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("title")],2),(_vm.showDivider)?_c('divider'):_vm._e(),_c('div',{staticClass:"card-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }